
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Ref } from "vue-property-decorator";
    import * as toastr from "toastr";
    import ApiClient from "@/utilities/ApiClient";
    import Utils from "@/utilities/Utils";
    import ApiButton from "@/vue/components/ApiButton.vue";
    import HtmlEditor from "@/vue/components/HtmlEditor.vue";
    import ConfirmDialogue from "@/vue/components/ConfirmDialogue.vue";
    import { ISaveResponse } from "@/model/ISaveResponse";
    import { ISiteLogEntry, SiteLogEntry } from "@/model/SiteLogEntry";

    @Component({ components: { ApiButton, ConfirmDialogue, HtmlEditor } })
    export default class SiteLogEntryDialogue extends Vue {

        //
        // -- properties
        //

        showDialogue: boolean = false;
        dialogueTitle: string = "";
        siteLogEntry: SiteLogEntry = new SiteLogEntry();
        get canDelete(): boolean { return !Utils.isEmptyId(this.siteLogEntry.id); }

        //
        // -- methods
        //

        add(siteID: string): void {
            this.reset();
            this.siteLogEntry.siteID = siteID;
            this.dialogueTitle = "Add Log Entry";
            this.showDialogue = true;
        }

        async edit(id: string): Promise<void> {
            this.reset();
            this.dialogueTitle = "Edit Log Entry";
            const siteLogEntryData: ISiteLogEntry = await ApiClient.get(`api/siteLogEntry/Load?id=${id}`);
            this.siteLogEntry.update(siteLogEntryData);
            this.showDialogue = true;
        }

        reset(): void {
            Utils.resetObject(this.siteLogEntry);
        }

        validateText(value?: string): string|boolean {
            if(!value) return "Please enter some text";
            return true;
        }

        async save(): Promise<void> {
            if (Utils.isEmptyOrWhitespace(this.siteLogEntry.text)) {
                toastr.warning("Please enter some text!", "Cannot Save");
                return;
            }
            const response: ISaveResponse = await ApiClient.post("/api/siteLogEntry/save", this.siteLogEntry, "site-log-entry-save");
            if(this.siteLogEntry.isNew) this.siteLogEntry.id = response.newID;
            toastr.success("Saved");
            this.$emit("saved");
            this.showDialogue = false;
        }

        confirmDelete(): void {
            const dialog: ConfirmDialogue = this.$refs.deleteDialogue as ConfirmDialogue;
            dialog.show();
        }

        async doDelete(): Promise<void> {
            await ApiClient.post("/api/siteLogEntry/delete", this.siteLogEntry, "siteLogEntry-delete");
            toastr.warning("Deleted");
            this.$emit("saved");
            this.showDialogue = false;
        }
    }
